<template>
  <el-dialog title="知识检索测试" :visible.sync="localVisible"
             width="720px" v-dialogDrag :modal-append-to-body="false" v-if="localVisible" @close="onClose">
    <div class="kb_search_form">
      <div class="query_row">
        <el-input v-model="query" placeholder="输入检索问题，如：首次电话沟通应该怎么开场？" clearable
                  @keyup.enter.native="doSearch" />
        <el-button type="primary" :loading="searching" @click="doSearch">检 索</el-button>
      </div>
      <div class="param_row">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="范围">
            <el-select v-model="scope" style="width: 160px">
              <el-option label="当前知识库" value="current" />
              <el-option label="全部知识库" value="all" />
            </el-select>
          </el-form-item>
          <el-form-item label="桶上限">
            <el-input-number v-model="maxBuckets" :min="1" :max="50" controls-position="right" style="width: 90px" />
          </el-form-item>
          <el-form-item label="分片上限">
            <el-input-number v-model="maxChunks" :min="1" :max="100" controls-position="right" style="width: 90px" />
          </el-form-item>
          <el-form-item label="字符预算">
            <el-input-number v-model="budgetTokens" :min="100" :step="500" controls-position="right" style="width: 110px" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-loading="searching" class="kb_search_result">
      <template v-if="result">
        <div class="res_meta">
          <span>命中 {{ (result.hits || []).length }} 条分片</span>
          <span>返回字符数：{{ result.tokens_used }}</span>
        </div>
        <div v-for="(hit, i) in result.hits || []" :key="hit.chunk_id || i" class="hit_item">
          <div class="hit_head">
            <el-tag size="mini">{{ hit.citation || '[' + (i + 1) + ']' }}</el-tag>
            <span class="hit_score">得分 {{ hit.score }}</span>
            <span class="hit_src" :title="hit.document_id">{{ hitSource(hit) }}</span>
          </div>
          <div class="hit_text">{{ hit.text }}</div>
        </div>
        <div v-if="!(result.hits || []).length" class="res_empty">未命中相关内容</div>
      </template>
      <div v-else class="res_empty">输入问题后点击检索</div>
    </div>
  </el-dialog>
</template>

<script>
import { agentBody } from '../utils'

// 知识检索测试弹窗：服务端 30s 超时；tokens_used 是返回文本字符数（非 LLM token）
export default {
  name: 'AiAgentKbSearch',
  props: {
    visible: { type: Boolean, default: false },
    kb: { type: Object, default: null }
  },
  data() {
    return {
      localVisible: this.visible,
      query: '',
      scope: 'current',
      maxBuckets: 4,
      maxChunks: 8,
      budgetTokens: 4000,
      searching: false,
      result: null
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
      if (val) this.result = null // 打开时清空上次结果
    },
    localVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    doSearch() {
      if (!this.query || !this.query.trim()) {
        return this.$message({ type: 'warning', message: '请输入检索问题' })
      }
      const data = { query: this.query.trim() }
      if (this.maxBuckets) data.max_buckets = this.maxBuckets
      if (this.maxChunks) data.max_chunks = this.maxChunks
      if (this.budgetTokens) data.budget_tokens = this.budgetTokens
      // 不传 kb_id/kb_ids = 当前 owner 全库
      if (this.scope === 'current' && this.kb) data.kb_id = this.kb.kb_id
      this.searching = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbSearch, agentBody(data)).then((res) => {
        if (res.data.code == 0) this.result = res.data.data
        this.searching = false
      }).catch((err) => {
        this.searching = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '检索失败，请稍后重试' })
      })
    },
    hitSource(hit) {
      const c = (this.result.citations || []).find(x => x.label === hit.citation)
      if (!c) return ''
      return c.section_title ? (c.page ? c.section_title + '（第' + c.page + '页）' : c.section_title) : ''
    },
    onClose() {
      this.searching = false
    }
  }
}
</script>

<style lang="less" scoped>
.kb_search_form {
  .query_row {
    display: flex;
    gap: 8px;
    margin-bottom: 4px;
  }
  .param_row {
    /deep/ .el-form { display: flex; flex-wrap: wrap; }
    /deep/ .el-form-item { margin-bottom: 4px; margin-right: 16px; }
  }
}
.kb_search_result {
  min-height: 120px;
  margin-top: 12px;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}
.res_meta {
  display: flex;
  justify-content: space-between;
  color: #909399;
  font-size: 13px;
  margin-bottom: 8px;
}
.hit_item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 8px;
}
.hit_head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.hit_score {
  color: #409eff;
  font-size: 13px;
}
.hit_src {
  color: #909399;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hit_text {
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
  white-space: pre-wrap;
  word-break: break-all;
}
.res_empty {
  text-align: center;
  color: #909399;
  padding: 32px 0;
  font-size: 13px;
}
</style>
